import ErrorToast from "@components/Common/ErrorTost";
import { languages } from "@constants/index";
import { toast } from "react-toastify";
import { mutate } from "swr";

export const ActiveArchiveCount = (
    dataTable: any,
    setNumberActive: Function,
    setNumberArchived: Function
) => {
    if (dataTable?.othersData) {
        if (dataTable.othersData.numberActive !== undefined) {
            setNumberActive(dataTable.othersData.numberActive);
            setNumberArchived(dataTable.othersData.numberArchive);
        } else {
            setNumberActive(0);
            setNumberArchived(0);
        }
    }
};
export const translatedLanguage = (t: any) => {
    return {
        [t("French")]: {
            fr: "Français",
            en: "French",
            nl: "Französisch",
            es: "Francés",
            pt: "Francês",
            it: "Francese",
        },
        [t("English")]: {
            fr: "Anglais",
            en: "English",
            nl: "Englisch",
            es: "Inglés",
            pt: "Inglés",
            it: " Inglese",
        },
        [t("German")]: {
            fr: "Allemand",
            en: "German",
            nl: "Deutsch",
            es: "Alemán",
            pt: "Alemão",
            it: "Tedesco",
        },
        [t("Spanish")]: {
            fr: "Espagnol",
            en: "Spanish",
            nl: "Spanisch",
            es: "Español",
            pt: "Espanhol",
            it: "Spagnolo",
        },
        [t("Italian")]: {
            fr: "Italien",
            en: "Italian",
            nl: " Italienisch",
            es: "Italiano",
            pt: " Italiano",
            it: " Italiano",
        },
        [t("Portuguese")]: {
            fr: "Portugais",
            en: "Portuguese",
            nl: "Portugiesisch",
            es: " Portugués",
            pt: "Português",
            it: " Portoghese",
        },
    };
};

export const checkIfLanguageExist = (
    languagesData: any,
    dataArchive: any,
    t: any,
    setLocalShop: any,
    langue: any,
    shopID: any,
    setSelectedRow: any
) => {
    let isLAnguageExist = false;
    let allLanguages = [...languagesData, ...dataArchive];
    allLanguages.forEach((element) => {
        if (element[t("Language")] === langue) {
            setLocalShop([shopID]);
            setSelectedRow([element]);
            isLAnguageExist = true;
            return;
        }
    });
    return isLAnguageExist;
};

export const checkIfLanguageFranchiseExistAndArchived = (
    archivedLanguageOfFranchise: any,
    t: any,
    setLocalShop: any,
    langue: any,
    shopID: any,
    setSelectedRow: any
) => {
    let isLAnguageExist = false;
    archivedLanguageOfFranchise.forEach((element: any) => {
        if (element[t("Language")] === langue) {
            setLocalShop([shopID]);
            setSelectedRow([element]);
            isLAnguageExist = true;
            return;
        }
    });
    return isLAnguageExist;
};

export const checkIfLanguageFranchiseExist = (
    languagesFranchise: any,
    t: any,
    setLocalShop: any,
    langue: any,
    shopID: any,
    setSelectedRow: any,
    displayName: any,
    country: any,
    uploadedImage: any,
    countryKeyValue: any,
    tableState: any,
    shopId: any,
    abbreviation: any,
    advancedDisplayName: any
) => {
    let isLanguageExist = false;

    languagesFranchise.forEach((element: any) => {
        if (element[t("Language")] === langue) {
            setLocalShop([shopID]);
            setSelectedRow([
                {
                    Id: element.Id,
                    [t("Language")]: langue,
                    display_name: displayName,
                    country: country,
                    url_image:
                        uploadedImage !== ""
                            ? uploadedImage
                            : `https://flagpedia.net/data/flags/h80/${countryKeyValue.toLowerCase()}.webp`,
                    isArchived: false,
                    isFavorite: tableState.rowData.isFavorite,
                    isActive: tableState.rowData.isActive,
                    shopId: shopId,
                    abbreviation: abbreviation,
                    advancedDisplayName: advancedDisplayName,
                },
            ]);
            isLanguageExist = true;
        }
    });

    return isLanguageExist;
};

export function getId(languageFormState: any, t: any) {
    switch (languageFormState.langue) {
        case t("French"):
            return "5c2ce585-68ca-49c8-9fda-d64f1e9fba40";

        case t("English"):
            return "3de90539-c727-40aa-a9a2-af84be160223";

        case t("German"):
            return "bb13c224-e4ae-493b-b8d5-1ab880e5ff2e";

        case t("Spanish"):
            return "0d436099-4cf6-4f26-9d2f-372d9a0207c5";

        case t("Italian"):
            return "dfa2b4f6-9bf3-4eb4-a171-0707deff50f3";

        case t("Portuguese"):
            return "bc9ecb8b-3527-4534-9154-7245b2ae58be";
    }
}

export const defaultLanguageFormState = {
    uploadedImage: "",
    langue: "",
    selectLangue: false,
    displayName: "",
    abbreviation: "",
    selectName: false,
    country: "",
    selectCountry: false,
    title: "",
    isModalOpened: false,
    isOpened: false,
    associated: [],
    countryOptions: [],
    isNotImg: false,
    selectImage: false,
    isLanguageExist: false,
    isValidateButtonDisabled: false,
    countryKey: "",
    borderColor: "none",
    advancedDisplayName: {
        languages: {
            fr: "",
            en: "",
            nl: "",
            es: "",
            pt: "",
            it: "",
        },
    },
    isAdvancedDisplayNameModalOpen: false,
};

export const defaultModalState = {
    isAddLanguageClicked: false,
    isInInitializationModalOpened: false,
    isHistoryModalOpened: false,
    isAssociateModified: false,
    isModalOpened: false,
    isAddNewLanguageButtonClicked: false,
};
export const defaultTableState = (oneShop: any, shopID: any) => {
    return {
        selectedRows: [] as any[],
        dataIsUpdated: false as boolean | number,
        filterActive: false,
        rowData: {},
        objectData: {},
        language: [] as any[],
        shopId: oneShop ? shopID : 0,
        selectedElement: {},
        isConsult: false,
    };
};
export async function fetchCountry(
    listOfCountry: any,
    AssociateLangues: any,
    setLanguageFormState: any,
    tableState: any,
    t: any
) {
    setLanguageFormState((prev: any) => {
        const row = tableState.rowData || {}; // fallback to empty object
        return {
            ...prev,
            selectCountry: false,
            selectLangue: false,
            selectName: false,
            isNotImg: false,
            selectImage: false,
            title: row.Id
                ? t(
                      tableState.isConsult
                          ? "View a language"
                          : "Modify a language"
                  )
                : prev.title,
            langue: row.Id ? row[t("Language")] : prev.langue,
            abbreviation: row.Id ? row.abbreviation : prev.abbreviation,
            displayName: row.Id ? row.display_name : prev.displayName,
            country: row.Id
                ? {
                      ...row.country,
                      label: t(row.country.label),
                  }
                : prev.country,
            uploadedImage: row.Id
                ? row.url_image.startsWith(
                      "https://flagpedia.net/data/flags/h80"
                  )
                    ? ""
                    : row.url_image
                : prev.uploadedImage,
            countryKey: row.Id ? row.country.code : prev.countryKey,
            advancedDisplayName: row.Id
                ? row.advancedDisplayName
                : prev.advancedDisplayName,
            associated: row.Id ? AssociateLangues : prev.associated,
            countryOptions: listOfCountry, // assuming this is always updated
        };
    });
}

export function AssociateLangues(
    shopsLanguagesData: any,
    item: any,
    defaultAssociated?: any
) {
    let idsAssociated: any[] = [];
    let associated: any[] = defaultAssociated || [];
    if (shopsLanguagesData !== undefined) {
        shopsLanguagesData.forEach((element: any) => {
            element.subRows.forEach((el: any) => {
                if (el.Id === item.Id) {
                    idsAssociated.push(el.shopId);
                    associated.push(el);
                }
            });
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return associated;
}

export function ArchivedLanguagesFranchise(archivedLanguageFranchise: any) {
    let idsAssociated: any[] = [];
    if (archivedLanguageFranchise !== undefined) {
        archivedLanguageFranchise.forEach((element: any) => {
            idsAssociated.push(element.Id);
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return idsAssociated;
}

export function ArchivedLanguages(shopsLanguagesData: any) {
    let idsAssociated: any[] = [];
    if (shopsLanguagesData !== undefined) {
        shopsLanguagesData.forEach((element: any) => {
            element.subRows.forEach((el: any) => {
                idsAssociated.push(el.Id);
            });
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return idsAssociated;
}

export async function isLanguageConsumed(
    e: any,
    t: any,
    franchiseID: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    toast.dismiss();
    let isLanguageUsed = false;
    const url = `${process.env.REACT_APP_API_V2_URL}/settings/consumedSettingGeneral?shopId=${e.selectedRow.shopId}&franchiseId=${franchiseID}&type=languages`;
    try {
        const result = await fetchGlobal<any>(url, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (result.data.some((el: any) => el.id === e.selectedRow.Id)) {
            isLanguageUsed = true;
        }

        mutate(url, result);
    } catch (error) {
        ErrorToast(`${t("There's an error")}`);
    }
    return isLanguageUsed;
}

export function AssociateLanguages(shopsLanguagesData: any) {
    let idsAssociated: any[] = [];
    if (shopsLanguagesData !== undefined) {
        shopsLanguagesData.forEach((element: any) => {
            if (element.subRows !== undefined) {
                element.subRows.forEach((el: any) => {
                    idsAssociated.push(el.Id);
                });
            }
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return idsAssociated;
}

export function isLanguageExist(
    tableState: any,
    dataAssociate: any,
    setIsLoading: any,
    setIsValidateArchiveOpened: any,
    t: any
) {
    let isExist = false;
    tableState.selectedRows.forEach((el: any) => {
        if (dataAssociate.includes(el.Id)) {
            isExist = true;
        }
    });
    if (isExist) {
        ErrorToast(
            `${t(
                "Please note that you cannot archive an item assigned to stores."
            )!}`
        );
        setIsLoading(false);
    } else {
        setIsLoading(false);
        setIsValidateArchiveOpened(true);
    }
}

export function ActiveArchiveCountShops(
    shopState: any,
    setNumberMultiShopActive: any,
    setNumberMultiShopArchived: any
) {
    let sumActive = 0;
    let sumArchive = 0;
    if (shopState.dataTable.data !== undefined) {
        shopState.selectedRows.length === 0 ||
        shopState.selectedRows.every((el: any) => el.subRows === undefined)
            ? shopState.dataTable.data.forEach((item: any) => {
                  sumActive =
                      item.numberActive !== undefined
                          ? sumActive + item.numberActive
                          : sumActive;
                  sumArchive =
                      item.numberArchive !== undefined
                          ? sumArchive + item.numberArchive
                          : sumArchive;
              })
            : shopState.selectedRows.forEach((item: any) => {
                  sumActive =
                      item.numberActive !== undefined
                          ? sumActive + item.numberActive
                          : sumActive;
                  sumArchive =
                      item.numberArchive !== undefined
                          ? sumArchive + item.numberArchive
                          : sumArchive;
              });
    }
    setNumberMultiShopActive(sumActive);
    setNumberMultiShopArchived(sumArchive);
}

export const defaultShopState = (shopID: any) => {
    return {
        filterActive: false,
        rowData: {},
        isShopSelected: false,
        isHistoryModalOpened: false,
        shopId: shopID,
        selectedRows: [],
        dataTable: { data: [] },
    };
};

export function getArrayOfRows(shopState: any, t: any) {
    let arrayOfRows: any[] = [];
    let ids: any[] = [];
    shopState.selectedRows.forEach(async (el: any) => {
        if (el[t("Shop")] !== undefined) {
            el.subRows.forEach((elt: any) => {
                if (ids.indexOf(`${elt.shopId}${elt.Id}`) === -1) {
                    arrayOfRows.push(elt);
                    ids.push(`${elt.shopId}${elt.Id}`);
                }
            });
        } else {
            if (ids.indexOf(`${el.shopId}${el.Id}`) === -1) {
                arrayOfRows.push(el);
                ids.push(`${el.shopId}${el.Id}`);
            }
        }
    });
    return arrayOfRows;
}

export const getArrayOfIds = (
    arrayIds: any,
    tableState: any,
    setArrayIds: any,
    t: any
) => {
    let array1 = [...arrayIds];
    tableState.selectedRows.forEach((element: any) => {
        if (element[t("Shop")] !== undefined) {
            element.subRows.forEach((elt: any) => {
                if (
                    array1.findIndex(
                        (el: any) =>
                            Object.keys(el)[0] === elt.shopId &&
                            Object.values(el)[0] === elt.Id
                    ) === -1
                )
                    array1.push({ [elt.shopId]: elt.Id });
            });
        } else {
            if (
                array1.findIndex(
                    (el: any) =>
                        Object.keys(el)[0] === element.shopId &&
                        Object.values(el)[0] === element.Id
                ) === -1
            )
                array1.push({ [element.shopId]: element.Id });
        }
    });
    setArrayIds(array1);
};

export function checkIfLanguageAssociated(shopId: string, shopRowData: any) {
    let associated = shopRowData.map((elt: any) => {
        if (elt.shopId === shopId) {
            return elt.subRows;
        } else {
            return null;
        }
    });
    return associated.filter((el: any) => el)[0];
}

export function CountIds(idsLocalShop: any, selectedRows: any, setIds: any) {
    let number = 0;
    idsLocalShop.forEach((el: any) => {
        selectedRows.forEach((v: any) => {
            if (v.Id === el) {
                number = number + 1;
            }
        });
    });
    setIds(number);
}

export function checkIfLanguageExistAndArchived(shopRowData: any) {
    let archived: any[] = [];
    if (shopRowData.length > 0) {
        shopRowData.forEach((element: any) => {
            if (element?.archivedLanguages !== undefined) {
                element?.archivedLanguages.forEach((el: any) => {
                    archived.push(el.Id);
                });
            }
        });
    }
    return archived;
}

export async function DataConsumed(
    shopId: string,
    t: any,
    franchiseID: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    toast.dismiss();
    let dataConsumed = {};
    const url = `${process.env.REACT_APP_API_V2_URL}/settings/consumedSettingGeneral?shopId=${shopId}&franchiseId=${franchiseID}&type=languages`;
    try {
        const result = await fetchGlobal<any>(url, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        dataConsumed = result.data;
        mutate(url, result);
    } catch (error) {
        ErrorToast(`${t("There's an error")}`);
    }
    return dataConsumed;
}

export const languagesOptions = (t: any) =>
    languages.map((element: any) => {
        return {
            label: t(element.label),
            value: element.value,
        };
    });

export function createDataLanguage(
    element: any,
    userID: any,
    franchiseID: string,
    operatorID: string,
    uuidUser: any,
    id: string,
    languageState: boolean,
    isArchived: boolean,
    isFavorite: boolean
) {
    return {
        userId: userID,
        shopId: [element.shopId],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        isShop: false,
        data: {
            [element.shopId.toString()]: {
                [id]: {
                    id: id,
                    language: languages.find(
                        (lg: any) => lg.value === element.abbreviation
                    )?.label,
                    display_name: element.display_name ?? element.displayName,
                    country: element.country,
                    urlImage: element.url_image,
                    isArchived: isArchived,
                    isFavorite: isFavorite,
                    isFavoriteShop: element.isFavorite,
                    isActive: languageState,
                    shopId: element.shopId,
                    abbreviation: element.abbreviation,
                    advancedDisplayName: element.advancedDisplayName,
                },
            },
        },
    };
}

export const apiRequest = async (
    dataLanguage: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>,
    additionalData?: any,
    image?: any
) => {
    const data = new FormData();
    data.append(
        "dataLanguage",
        JSON.stringify({ dataLanguage, ...additionalData })
    );
    data.append("image", image || "");
    let API_LANGUAGE_ENDPOINT = `${process.env.REACT_APP_API_V2_URL}/settings/general/language`;

    return await fetchGlobal<any>(API_LANGUAGE_ENDPOINT, {
        method: "POST",
        body: data,
    });
};

export const TOAST_CONFIG = {
    position: toast.POSITION.TOP_CENTER,
    theme: "colored" as const,
};

export function processRows(
    arrayOfRows: any,
    dataConsumed: any,
    shopIds: any,
    languageData: any,
    itemsDisable: any,
    setItemsDisable: Function
) {
    let isSomeFavorite: any = false;
    let isSomeConsumed: any = false;
    for (let el of arrayOfRows) {
        const id = el.Id;
        if (el.isFavorite === true) {
            isSomeFavorite = true;
        } else {
            let isConsumed =
                Object.keys(dataConsumed).includes(el.shopId) &&
                dataConsumed[el.shopId].some((elt: any) => elt.id === el.Id);
            if (isConsumed === true) {
                isSomeConsumed = true;
            } else {
                if (!shopIds.includes(el.shopId.toString())) {
                    shopIds.push(el.shopId.toString());
                    languageData[el.shopId.toString()] = {};
                }
                Object.assign(languageData[el.shopId.toString()], {
                    [id]: {
                        id: id,
                        language: languages.find(
                            (lg: any) => lg.value === el.abbreviation
                        )?.label,
                        display_name: el.display_name,
                        country: el.country,
                        urlImage: el.url_image,
                        abbreviation: el.abbreviation,
                        isArchived: true,
                        shopId: el.shopId,
                        isActive: false,
                        isFavorite: el.isFavorite,
                        advancedDisplayName: el.advancedDisplayName,
                    },
                });

                if (
                    el.isActive === false &&
                    itemsDisable.find(
                        (item: any) =>
                            item.id === id && item.shopId === el.shopId
                    ) !== undefined
                ) {
                    const element = itemsDisable.filter(
                        (item: any) =>
                            !(item.id === id && item.shopId === el.shopId)
                    );
                    setItemsDisable(element);
                }
            }
        }
    }
    return { isSomeFavorite, isSomeConsumed };
}
export function processRowsShops(
    selectedRows: any,
    dataConsumed: any,
    idShops: any,
    languageData: any
) {
    let isSomeConsumed: any = false;
    let isFavorite: any = false;
    for (let el of selectedRows) {
        const id = el.Id;
        if (el.isFavorite === true) {
            isFavorite = true;
        } else {
            let isConsumed =
                Object.keys(dataConsumed).includes(el.shopId) &&
                dataConsumed[el.shopId].some((elt: any) => elt.id === el.Id);
            if (isConsumed === true) {
                isSomeConsumed = true;
            } else {
                if (!idShops.includes(el.shopId.toString())) {
                    idShops.push(el.shopId).toString();
                    languageData[el.shopId.toString()] = {};
                }
                Object.assign(languageData[el.shopId.toString()], {
                    [id]: {
                        id: id,
                        language: languages.find(
                            (lg: any) => lg.value === el.abbreviation
                        )?.label,
                        display_name: el.display_name,
                        country: el.country,
                        urlImage: el.url_image,
                        abbreviation: el.abbreviation,
                        isArchived: true,
                        shopId: el.shopId,
                        isFavorite: el.isFavorite,
                        isActive: false,
                        advancedDisplayName: el.advancedDisplayName,
                    },
                });
            }
        }
    }
    return { isSomeConsumed, isFavorite };
}

export function ArchivedLanguagesShop(e: any, shopsLanguagesData: any) {
    let idsAssociated = [0];
    if (shopsLanguagesData !== undefined) {
        shopsLanguagesData.forEach((element: any) => {
            element.subRows.forEach((el: any) => {
                if (el.Id === e.Id) idsAssociated.push(el.shopId);
            });
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return idsAssociated;
}

export function createLanguageItem(
    element: any,
    id: string,
    languageState: boolean,
    isArchived: boolean,
    isFavorite: boolean,
    shopId: any,
    language?: any,
    isReassignment?: any
) {
    return {
        [id]: {
            id: id,
            language:
                language ??
                languages.find((lg: any) => lg.value === element.abbreviation)
                    ?.label,
            display_name: element.display_name ?? element.displayName,
            country: element.country,
            urlImage: element.url_image,
            isArchived: isArchived,
            isFavorite: isFavorite,
            isFavoriteShop: element.isFavorite,
            isActive: languageState,
            shopId: shopId,
            abbreviation: element.abbreviation,
            advancedDisplayName: element.advancedDisplayName,
            isReassignment: isReassignment ?? false,
        },
    };
}
